// ==================== COSTANTI E CONFIGURAZIONI ====================

export const TERMINAL_DATA = {
  'PSW': { nome: 'Puntalino singolo Bianco', len: 0, peel: 0, printOffset: 15 },
  'PSR': { nome: 'Puntalino singolo Rosso', len: 0, peel: 0, printOffset: 15 },
  'PSN': { nome: 'Puntalino singolo Nero', len: 0, peel: 0, printOffset: 15 },
  'PSB': { nome: 'Puntalino singolo Blu', len: 0, peel: 0, printOffset: 16 },
  'PSG': { nome: 'Puntalino singolo Grigio', len: 14, peel: 5, printOffset: 18 },
  'PSY': { nome: 'Puntalino singolo Giallo', len: 15, peel: 5, printOffset: 21 },
  'PSR10': { nome: 'Puntalino singolo Rosso 10 mm', len: 0, peel: 0, printOffset: 0 },
  'PSB10': { nome: 'Puntalino singolo Blu 10 mm', len: 0, peel: 0, printOffset: 0 },
  'PDW': { nome: 'Puntalino doppio Bianco', len: 12.5, peel: 5, printOffset: 16 },
  'PDR': { nome: 'Puntalino doppio Rosso', len: 12.5, peel: 5, printOffset: 16 },
  'PDN': { nome: 'Puntalino doppio Nero', len: 12.5, peel: 5, printOffset: 17 },
  'PDB': { nome: 'Puntalino doppio Blu', len: 14, peel: 5, printOffset: 20 },
  'PDG': { nome: 'Puntalino doppio Grigio', len: 17, peel: 8, printOffset: 23 },
  'PDY': { nome: 'Puntalino doppio Giallo', len: 20, peel: 8, printOffset: 26 },
  'PDR10': { nome: 'Puntalino doppio Rosso 10 mm', len: 0, peel: 0, printOffset: 0 },
  'FSR2.8': { nome: 'Faston scoperto Rosso 2.8mm', len: 7, peel: 5, printOffset: 10 },
  'FSR4.8': { nome: 'Faston scoperto Rosso 4.8mm', len: 7, peel: 5, printOffset: 10 },
  'FSR6.3': { nome: 'Faston scoperto Rosso 6.3mm', len: 7, peel: 5, printOffset: 10 },
  'FCR4.8': { nome: 'Faston coperto Rosso 4.8mm', len: 7, peel: 5, printOffset: 10 },
  'FCR6.3': { nome: 'Faston coperto Rosso 6.3mm', len: 7, peel: 5, printOffset: 10 },
  'FCB4.8': { nome: 'Faston coperto Blu 4.8mm', len: 7, peel: 5, printOffset: 10 },
  'FCB6.3': { nome: 'Faston coperto Blu 6.3mm', len: 7, peel: 5, printOffset: 10 },
  'FAS': { nome: 'Faston a squadra', len: 7, peel: 5, printOffset: 10 },
  'FR3': { nome: 'Forcina Rossa 3mm', len: 7, peel: 5, printOffset: 10 },
  'FR4': { nome: 'Forcina Rossa 4mm', len: 7, peel: 5, printOffset: 10 },
  'FB3': { nome: 'Forcina Blu 3mm', len: 7, peel: 5, printOffset: 10 },
  'FB4': { nome: 'Forcina Blu 4mm', len: 7, peel: 5, printOffset: 10 },
  'FY3': { nome: 'Forcina Gialla 3mm', len: 7, peel: 5, printOffset: 10 },
  'FY4': { nome: 'Forcina Gialla 4mm', len: 7, peel: 5, printOffset: 10 },
  'OR4': { nome: 'Occhiello Rosso 4mm', len: 7, peel: 5, printOffset: 10 },
  'OR5': { nome: 'Occhiello Rosso 5mm', len: 7, peel: 5, printOffset: 10 },
  'OR6': { nome: 'Occhiello Rosso 6mm', len: 7, peel: 5, printOffset: 10 },
  'OB4': { nome: 'Occhiello Blu 4mm', len: 7, peel: 5, printOffset: 10 },
  'OB5': { nome: 'Occhiello Blu 5mm', len: 7, peel: 5, printOffset: 10 },
  'OB6': { nome: 'Occhiello Blu 6mm', len: 7, peel: 5, printOffset: 10 },
  'OY4': { nome: 'Occhiello Giallo 4mm', len: 7, peel: 5, printOffset: 10 },
  'OY5': { nome: 'Occhiello Giallo 5mm', len: 7, peel: 5, printOffset: 10 },
  'OY6': { nome: 'Occhiello Giallo 6mm', len: 7, peel: 5, printOffset: 10 },
  'MLM': { nome: 'Mate-n-lok Maschio', len: 4.5, peel: 5, printOffset: 5 },
  'MLF': { nome: 'Mate-n-lok Femmina', len: 4.5, peel: 5, printOffset: 5 },
  'TR': { nome: 'Tubetto Rosso', len: 5.5, peel: 3, printOffset: 10 },
  'TB': { nome: 'Tubetto Blu', len: 5.5, peel: 3, printOffset: 10 },
  'TY': { nome: 'Tubetto Giallo', len: 6, peel: 3, printOffset: 10 },
  'NS': { nome: 'No Spelatura', len: 0, peel: 0, printOffset: 0 },
  'SP': { nome: 'Spelatura Personalizzata', len: 0, peel: 0, printOffset: 0 }
};

// Gruppi per organizzare i terminali nel dropdown
export const TERMINAL_GROUPS = {
  'Puntalini Singoli': ['PSW', 'PSR', 'PSN', 'PSB', 'PSG', 'PSY', 'PSR10', 'PSB10'],
  'Puntalini Doppi': ['PDW', 'PDR', 'PDN', 'PDB', 'PDG', 'PDY', 'PDR10'],
  'Faston': ['FSR2.8', 'FSR4.8', 'FSR6.3', 'FCR4.8', 'FCR6.3', 'FCB4.8', 'FCB6.3', 'FAS'],
  'Forcine': ['FR3', 'FR4', 'FB3', 'FB4', 'FY3', 'FY4'],
  'Occhielli': ['OR4', 'OR5', 'OR6', 'OB4', 'OB5', 'OB6', 'OY4', 'OY5', 'OY6'],
  'Mate-n-lok': ['MLM', 'MLF'],
  'Tubetti': ['TR', 'TB', 'TY'],
  'Altri': ['NS', 'SP']
};

// Terminali con grafiche custom
export const CUSTOM_TERMINALS = ['PSW', 'PSR', 'PSN', 'PSB', 'PSG', 'PSY', 'PSR10', 'PSB10', 'PDW', 'PDR', 'PDN', 'PDB', 'PDG', 'PDY', 'PDR10', 'FR3', 'FR4', 'FB3', 'FB4', 'FY3', 'FY4', 'OR4', 'OR5', 'OR6', 'OB4', 'OB5', 'OB6', 'OY4', 'OY5', 'OY6', 'MLM', 'MLF', 'TR', 'TB', 'TY', 'FSR2.8', 'FSR4.8', 'FSR6.3',  'FCR4.8', 'FCR6.3', 'FCB4.8', 'FCB6.3', 'FAS'];

// ==================== SCALE DI RENDERING TERMINALI ====================

// Mappa delle sezioni comuni con fattori di scala per il rendering dei terminali
export const SECTION_SCALE_MAP = {
  // Sezioni molto piccole
  0.25: 0.05,
  0.5: 0.05,
  0.75: 0.05,
  1.0: 0.05,
  1.5: 0.05,
  
  // Sezioni standard
  2.5: 0.05,
  4.0: 0.055,
  6.0: 0.07,  // Scala di riferimento
  10.0: 0.08,
};

// Scala base per terminali
export const BASE_TERMINAL_SCALE = 0.04;

// Limiti per la scala dei terminali
export const MIN_TERMINAL_SCALE = 0.06;
export const MAX_TERMINAL_SCALE = 0.50;

// Fattore proporzionale per calcolo scala (baseScale + (sezione / 100) * FACTOR)
export const TERMINAL_SCALE_PROPORTIONAL_FACTOR = 0.4;